import { CardSvg } from '@/play/cardSvg'

/** Home card art for Candy: a sprinkled pink donut, a swirl lollipop and two jelly beans on mint. */
export function CandyCardArt() {
  const sprinkles: [number, number, number, string][] = [
    [128, 70, 20, '#2f7bff'], [150, 62, -40, '#ffc21a'], [172, 72, 60, '#fff4ea'], [182, 96, -10, '#34c759'],
    [172, 122, 35, '#a855f7'], [146, 132, -60, '#ff2d55'], [122, 120, 15, '#ffc21a'], [112, 96, 80, '#2f7bff'],
  ]
  return (
    <CardSvg bg="#d4f3e4">
      <ellipse cx="150" cy="104" rx="66" ry="56" fill="#b97a3e" />
      <ellipse cx="150" cy="98" rx="66" ry="56" fill="#d99a55" />
      <path d="M150 50 C 175 48, 204 66, 204 96 C 206 124, 180 146, 150 144 C 122 146, 95 128, 96 98 C 94 70, 122 48, 150 50 Z" fill="#ff6fae" />
      <ellipse cx="150" cy="98" rx="20" ry="16" fill="#b97a3e" />
      <ellipse cx="150" cy="100" rx="17" ry="13" fill="#d4f3e4" />
      <path d="M118 70 Q 132 58 150 57" stroke="#fff" strokeWidth="5" strokeLinecap="round" fill="none" opacity="0.7" />
      {sprinkles.map(([x, y, a, c], i) => (
        <rect key={i} x={x - 7} y={y - 2.6} width="14" height="5.2" rx="2.6" fill={c} transform={`rotate(${a} ${x} ${y})`} />
      ))}
      <path d="M262 92 L 290 176" stroke="#fffaf0" strokeWidth="7" strokeLinecap="round" />
      <circle cx="258" cy="72" r="32" fill="#fff4ea" />
      <path d="M258 72 m0 -3 a3 3 0 1 1 -3 3 a8 8 0 0 1 8 -8 a14 14 0 0 1 14 14 a20 20 0 0 1 -20 20 a26 26 0 0 1 -26 -26" fill="none" stroke="#ff2d55" strokeWidth="7" strokeLinecap="round" />
      <path d="M36 150 C 30 136, 46 126, 58 134 C 64 138, 72 136, 76 144 C 80 156, 62 166, 50 164 C 42 163, 38 158, 36 150 Z" fill="#a855f7" />
      <path d="M50 178 C 46 168, 58 160, 68 166 C 72 169, 80 167, 84 173 C 86 182, 74 190, 64 188 C 56 187, 52 184, 50 178 Z" fill="#ffc21a" />
      <path d="M44 140 Q 48 134 54 134" stroke="#fff" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.8" />
    </CardSvg>
  )
}
